import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Nationality } from 'src/app/models/national.models';
import { TITLE } from 'src/app/utils/enum';
import { FormFieldInfo } from '../../../../models/forms-response.models';
import { FormsService } from '../../../../services/forms.service';

@Component({
    selector: 'app-component-single-select',
    templateUrl: './single-select.component.html',
    styleUrls: ['./single-select.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SingleSelectComponent implements OnInit, OnChanges, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Output() selectEmit = new EventEmitter();
    @Input() inputData: any;
    @Input() formData: any;
    @Input() formGroup: any;
    @Input() modalTitle: any;
    name: string;
    placeHolder: string;
    data = [];
    formFieldConfig: any;
    fieldConfig: any;
    labelId: string;
    hideTitle: boolean;
    fieldCode: string;
    currentSelect: Nationality = { dataValueField: '', dataTextField: '' };
    input: string;
    urlGetData: string;
    prefix: string = "";
    value: string;
    tooltip: string;
    isLoading: boolean;
    fieldDataInfo: any;
    taxCode = "";
    formCode = "";
    shortTitle: string = '';
    timeout: number = 30000;

    constructor(private cdref: ChangeDetectorRef, private formsService: FormsService) { }

    ngOnChanges(): void {
        if (this.inputData && this.inputData.fieldCode == this.formFieldInfo.fieldCode) {
            this.data = this.inputData.data;
            if (this.data.length > 0) {
                if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
                {
                    let arrDefaultValue = this.formFieldInfo && this.formFieldInfo.defaultValue ? this.formFieldInfo.defaultValue.split('|') : this.formFieldConfig && this.formFieldConfig.defaultValue ? this.formFieldConfig.defaultValue.split('|') : "";
                    this.currentSelect = this.setCurrentValue(arrDefaultValue[0]);
                }
                else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
                    if (this.formData) {
                        let objectData = this.formData;
                        const keys = Object.keys(objectData);
                        keys.forEach((key) => {
                            if (key == this.formFieldInfo.fieldCode) {
                                let value = objectData[key];
                                this.currentSelect = this.setCurrentValue(value);
                            }
                        });
                    }
                }
                else {
                    this.formCode = localStorage.getItem('FORM_CODE');
                    this.taxCode = localStorage.getItem('TAXCODE');
                    let storageVal = localStorage.getItem(("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.fieldCode));
                    this.currentSelect = this.setCurrentValue(storageVal);
                }
            }
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.isLoading = false;
        }, this.timeout)
        
        this.isLoading = true;
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.fieldDataInfo = this.formFieldInfo;
            this.labelId = `label-single-select-${this.formFieldInfo.fieldCode}`;
            if (this.fieldConfig) {
                this.input = (this.fieldConfig.apiConfig && this.fieldConfig.apiConfig.request) ? this.fieldConfig.apiConfig.request.input : "";
                this.urlGetData = this.fieldConfig.apiConfig && this.fieldConfig.apiConfig.url ? this.fieldConfig.apiConfig.url : "";
                this.prefix = this.fieldConfig.apiConfig && this.fieldConfig.apiConfig.prefix ? this.fieldConfig.apiConfig.prefix : "";
            }
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;
            this.placeHolder = `--${this.name}--`;
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
            this.formCode = localStorage.getItem('FORM_CODE');
            this.taxCode = localStorage.getItem('TAXCODE');
            this.loadDataForThis(this.formFieldInfo);
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }

        if(this.currentSelect){
            this.shortTitle = this.currentSelect.dataValueField;
        }
        else{
            this.shortTitle = '';
        }
    }

    changeSelect(event: any) {
        this.selectEmit.emit({ fieldInfo: this.formFieldInfo, input: this.currentSelect });
        if (this.data.length > 0) {
            if (this.currentSelect && this.currentSelect.dataValueField) {
                localStorage.setItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.fieldCode, this.currentSelect.dataValueField);
                
            } else {
                if (!localStorage.getItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.fieldCode)) {
                    localStorage.setItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.fieldCode, '');
                }
                else {
                    this.currentSelect = this.setCurrentValue();
                }
            }
        }

        if(this.currentSelect){
            this.shortTitle = this.currentSelect.dataValueField;
        }
        else{
            this.shortTitle = '';
        }
    }

    loadDataForThis(formFieldInfo: any) {
        if (formFieldInfo.customfieldOptionList != null && formFieldInfo.customfieldOptionList.length > 0) {
            let singleSelectList = [];
            formFieldInfo.customfieldOptionList.forEach(element => {
                let singleSelectObject = { dataValueField: '', dataTextField: '' };
                singleSelectObject.dataValueField = element.optionCode;
                singleSelectObject.dataTextField = element.optionValue;
                singleSelectList.push(singleSelectObject);
            });

            this.data = singleSelectList;
            let arrDefaultValue = this.formFieldInfo && this.formFieldInfo.defaultValue ? this.formFieldInfo.defaultValue.split('|') : this.formFieldConfig && this.formFieldConfig.defaultValue ? this.formFieldConfig.defaultValue.split('|') : "";
            this.currentSelect = this.setCurrentValue(arrDefaultValue[0]);
            this.setLocalStorageValue(this.data);
        }
        else {
            if (this.urlGetData) {
                if (this.input && (this.input.startsWith('SELECTLIST_SINGLE_') || this.input.startsWith('SYS_'))) {
                    let abc = (this.formGroup.controls[this.input].value).dataValueField ? (this.formGroup.controls[this.input].value).dataValueField : '';
                    this.formsService.callApiUrl(this.urlGetData, { input: this.prefix + abc }).subscribe(
                        res => {
                            this.bindingDataAfterCallApi(res)
                        },
                        error => {
                            console.log(error);
                        }
                    )
                } else if (this.input) {
                    this.formsService.callApiUrl(this.urlGetData, { input: this.input }).subscribe(
                        res => {
                            this.bindingDataAfterCallApi(res)
                        },
                        error => {
                            console.log(error);
                        }
                    )
                } else {
                    this.formsService.callApiUrl(this.urlGetData, {}).subscribe(
                        res => {
                            this.bindingDataAfterCallApi(res)
                        },
                        error => {
                            console.log(error);
                        }
                    )
                }
            }
            else {
                this.data = [];
                this.isLoading = false;
            }
        }
    }

    bindingDataAfterCallApi(res: any) {
        if (this.formFieldConfig && this.formFieldConfig.condition) {
            let formula = this.formFieldConfig.condition;
            let data = [];
            formula = formula.replace(/\$/g, '');
            res.result.forEach((item, idx) => {
                let valid = eval(this.formFieldConfig.condition);
                if (valid) data.push(item);
            });

            this.data = data;
        }
        else if(res.result.result){
            this.data = res.result.result
        }
        else {
            this.data = res.result
        }

        this.bindingDefaultData();
        this.setLocalStorageValue(this.data);
        this.isLoading = false;
    }

    setLocalStorageValue(data: any) {
        if (data.length > 0) {
            localStorage.setItem(this.urlGetData + JSON.stringify(this.fieldConfig.apiConfig.request) + JSON.stringify(this.input), JSON.stringify(data));
        }
    }

    bindingDefaultData() {
        if (this.modalTitle == TITLE.ADD_DATA) {
            let arrDefaultValue = this.formFieldInfo && this.formFieldInfo.defaultValue ? this.formFieldInfo.defaultValue.split('|') : this.formFieldConfig && this.formFieldConfig.defaultValue ? this.formFieldConfig.defaultValue.split('|') : "";
            this.currentSelect = this.setCurrentValue(arrDefaultValue[0]);
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) {
            if (this.formData) {
                let objectData = this.formData;
                for (let key in objectData){
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.currentSelect = this.setCurrentValue(value);
                    }
                }
            }
        }
        else {
            let storageVal = localStorage.getItem(("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.fieldCode));
            if (storageVal) {
                this.currentSelect = this.setCurrentValue(storageVal);
            }
            else {
                let arrDefaultValue = this.formFieldInfo && this.formFieldInfo.defaultValue ? this.formFieldInfo.defaultValue.split('|') : this.formFieldConfig && this.formFieldConfig.defaultValue ? this.formFieldConfig.defaultValue.split('|') : "";
                this.currentSelect = this.setCurrentValue(arrDefaultValue[0]);
            }
        }
    }

    setCurrentValue(valueToFilter: string = null){
        let result: any;
        if(valueToFilter){
            if(valueToFilter.includes('|'))
                valueToFilter = valueToFilter.split('|')[0];
            
            result = this.data.find(x => x.dataValueField == valueToFilter || x.dataTextField == valueToFilter);
            if(result)
                return result;
        }
        else if(!valueToFilter){
            result = this.data.find(x => x.dataValueField == localStorage.getItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.fieldCode));
            if(result)
                return result;
            
            let local = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode + '_' + this.taxCode + '_' + this.fieldCode);
            if(local && local.includes('|'))
                local = local.split('|')[0];

            result = this.data.find(x => x.dataValueField == local);
            if(result)
                return result;
        }
        this.shortTitle = this.currentSelect.dataValueField ? this.currentSelect.dataValueField : '';
        return '';
    }
}